<template>
  <div class="forum">
    <img :src="banner.imgUrl" class="cov-img page-banner" alt="">
    <div class="instro center">
      <pane-title title="论坛介绍" sub-title="Introduction" />

      <div class="desc">
        <div class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
          <p v-for="(item, i) in (intro.description || '').split('|')" :key="i">{{item}}</p>
        </div>
        <img :src="intro.pcImgUrl" alt="">
      </div>
    </div>

    <div class="background">
      <div class="center">
        <pane-title title="成立背景" sub-title="Background" />
      </div>

      <div class="pur-con bg-box">
        <div v-for="item in background" :key="item.id">
          <img :src="item.pcImgUrl" alt="">
          <span :style="{height: lang === 'zh' ? '' : '120px'}">{{item.title}}</span>
          <div></div>
          <p class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">{{item.description}}</p>
        </div>
      </div>
    </div>

    <div class="mission center">
      <pane-title title="愿景与使命" sub-title="Vision and mission" />

      <div class="con">
        <div class="box box-1">
          <div class="left-box">
            <p class="txt-lg">{{ lang === 'zh' ? '愿' : 'V' }}</p>
            <div>
              <p>GF60{{lang === 'zh' ? '愿景' : 'Vision'}}</p>
              <p class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">{{lang === 'zh' ? vision : enVision}}</p>
            </div>
          </div>
          <div class="right-box">
            <p class="txt-mid" :style="{marginBottom: lang === 'zh' ? '' : '-40px'}">{{lang === 'zh' ? '景' : 'VISION'}}</p>
            <div class="img"></div>
          </div>
        </div>
        <div class="line-box" :style="{marginBottom: lang === 'zh' ? '' : '50px'}"></div>
        <div class="box box-2">
          <div class="left-box">
            <p
                class="txt-mid"
                :style="{marginBottom: lang === 'zh' ? '' : '-40px'}"
            >{{lang === 'zh' ? '使' : 'MISSION'}}</p>
            <div class="img"></div>
          </div>
          <div class="right-box">
            <p class="txt-lg">{{ lang === 'zh' ? '命' : 'M' }}</p>
            <div>
              <p>GF60{{lang === 'zh' ? '使命' : 'Mission'}}</p>
              <p class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">{{lang === 'zh' ? mission : enMission}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--
    <div class="work center" :class="{enWork: lang === 'en'}">
      <pane-title title="工作重点" sub-title="Aims" />
      <div class="con">
        <img v-show="lang === 'en'" src="../../assets/about/bottom.jpg" alt="">
        <div class="box-1" v-show="lang === 'zh'">
          <div class="left">
            <div>
              <p class="tit">
                {{workFocusList[0].title}}
              </p>
              <p class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
                {{workFocusList[0].description}}
              </p>
            </div>
            <div>
              <p class="tit">
                {{workFocusList[1].title}}
              </p>
              <p class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
                {{workFocusList[1].description}}
              </p>
            </div>
          </div>
          <div class="img"></div>
          <div class="right">
            <div>
              <p class="tit">
                {{workFocusList[2].title}}
              </p>
              <p class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
                {{workFocusList[2].description}}
              </p>
            </div>
            <div>
              <p class="tit">
                {{workFocusList[3].title}}
              </p>
              <p class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
                {{workFocusList[3].description}}
              </p>
            </div>
          </div>
        </div>
        <div class="box-2" v-show="lang === 'zh'">
          <p class="tit">
            {{workFocusList[4].title}}
          </p>
          <p class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
            {{workFocusList[4].description}}
          </p>
        </div>
      </div>
    </div>
      -->

    <div class="research-area">
      <div class="center">
        <pane-title title="研究方向" sub-title="Research Area" />

        <div class="area-list">
          <div class="area-item" v-for="(item, i) in researchAreaList" :key="i">
            <img :src="require('../../assets/about/' + item.imgUrl)" alt="">
            <div :class="{'tit-box': true, 'tit-box-3': i === 2}">
              <p>{{lang === 'zh' ? item.tit : item.enTit}}</p>
              <span v-if="lang === 'zh'">{{item.enTit}}</span>
            </div>

            <div class="desc-box" :class="lang === 'en' ? 'en-desc-box' : ''">{{lang === 'zh' ? item.desc : item.enDesc}}</div>
          </div>
        </div>
      </div>

      <div class="area-menu-list center">
        <div class="am-item" v-for="(item, i) in researchMenuList">
          <img :src="require('../../assets/about/' + item.imgUrl)" alt="">
          <p>{{lang === 'zh' ? item.tit : item.enTit}}</p>
        </div>
      </div>

      <div class="bg-box" />
    </div>

    <div class="scope-work center">
      <pane-title title="运营模块" sub-title="Scope of Work" />

      <div class="sw-item" v-for="(item, i) in scopeWorkList" :key="i">
        <div class="order"><span>{{item.order}}</span></div>
        <div class="txt-box">
          <div class="tit">{{lang === 'zh' ? item.tit : item.enTit}}</div>
          <div v-if="lang === 'zh'" class="sub-tit">{{item.enTit}}</div>
          <div class="line" />
          <div class="desc-box">{{lang === 'zh' ? item.desc : item.enDesc}}</div>
        </div>
        <div class="img">
          <img :src="require('../../assets/about/' + item.imgUrl)" alt="">
        </div>
      </div>
    </div>

    <div class="milstone center">
      <pane-title title="里程碑" sub-title="Milestone" />

      <img :src="lcbImgUrl" alt="">
    </div>
  </div>
</template>

<script>
import {forumPageData, researchAreaList, researchMenuList, scopeWorkList, testLCBList,} from "../../utils/Local-Data";
const {
  vision, mission, enVision, enMission
} = forumPageData;

export default {
  name: "Forum",
  data() {
    return {
      banner: {},
      intro: {},
      background: [],
      workFocusList: [{}, {}, {}, {}, {}],
      vision, mission,
      enVision, enMission, researchAreaList, researchMenuList, scopeWorkList, testLCBList,
      lcbImgUrl: ''
    }
  },
  computed: {
    lang() {
      return this.$store.state.plang;
    }
  },
  methods: {
    filterData(records) {
      this.lcbImgUrl = records['220'][0].jumpUrl;
      this.intro = records['201'][0];
      this.background = records['202'];
      this.workFocusList = records['204'];
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '2',
        platform: 'pc',
        language
      }).then(res => {
        this.filterData(res.crmOweContentMaps || {});
        this.banner = res.imageMaps['20'][0];
      });
    },
    getDataByLang(lang) {
      if(lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    }
  }
}
</script>

<style lang="less">
.pc-home {
  .forum {
    .desc {
      font-size: 0;
      >* {
        display: inline-block;
        vertical-align: middle;
      }
      margin-bottom: 87px;
      div {
        width: calc(100% - 313px);
        p {
          font-size: 18px;
          text-indent: 2em;
          color: #494949;
          line-height: 29px;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      img {
        width: 253px;
        margin-left: 60px;
      }
    }
    .pur-con {
      padding: 50px 0;
      display: flex;
      justify-content: center;
      text-align: center;
      background-image: url("../../assets/bg-2.jpg");
      margin: 40px 0 92px;
      >div {
        margin: 0 80px;
        width: 420px;
        div {
          width: 78px;
          height: 1px;
          background: #7d7d7d;
          margin: 30px auto 20px;
        }
      }
      img {
        display: block;
        width: 91px;
        margin: 0 auto 31px;
      }
      span {
        width: 420px;
        display: inline-block;
        font-size: 26px;
        color: #037698;
        font-weight: bolder;
      }
      p {
        width: 90%;
        margin: 0 auto;
        text-indent: 2em;
      }
    }
    .mission {
      margin-bottom: 92px;
      .txt-lg {
        width: 310px;
        font-size: 328px;
        font-weight: bolder;
        line-height: 315px;
        color: #f3f3f3;
      }
      .txt-mid {
        font-size: 130px;
        line-height: 125px;
        font-weight: bolder;
        background-image: linear-gradient(180deg, #D7BB84 0%, #CDA866 54.8095703125%, #997333 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .box-1, .box-2 {
        display: flex;
      }
      .box-1 .left-box {
        margin-right: 15px;
        .txt-lg {
          text-align: right;
        }
      }
      .box-2 .right-box {
        margin-left: 15px;
      }
      .box-1 .left-box, .box-2 .right-box {
        position: relative;
        >div {
          width: 100%;
          position: absolute;
          bottom: 0;
          p {
            &:nth-child(1) {
              font-size: 24px;
              color: #037698;
              letter-spacing: 2px;
              margin-bottom: 20px;
            }
            &:nth-child(2) {
              text-indent: 2em;
              padding-bottom: 30px;
              line-height: 29px;
            }
          }
        }
      }
      .box-1 .right-box  {
        .img {
          background-image: url("../../assets/about/con-2.jpg");
        }
      }
      .box-2 .left-box {
        .img {
          background-image: url("../../assets/about/con-1.jpg");
        }
        .txt-mid {
          text-align: right;
        }
      }
      .box-1 .right-box, .box-2 .left-box {
        flex-grow: 1;
        .img {
          height: 200px;
          background-size: cover;
          background-position: 50% 50%;
          background-repeat: no-repeat;
          margin-top: -13px;
        }
      }
      .line-box {
        width: 40%;
        height: 1px;
        margin-top: 70px;
        background: #7d7d7d;
        position: relative;
        &:after {
          display: inline-block;
          content: '';
          width: 11px;
          height: 11px;
          background: #7d7d7d;
          border-radius: 50%;
          position: absolute;
          top: -5px;
          right: 0;
        }
      }
    }
    .work {
      margin-bottom: 120px;
      .pane-title {
        margin-bottom: 0;
      }
      .con {
        img {
          display: block;
          width: 100%;
        }
        .tit {
          font-size: 26px;
          color: #037698;
          font-weight: bolder;
          line-height: 44px;
          text-align: right;
        }
        .txt {
          line-height: 27px;
          text-indent: 2em;
        }
        .box-1 {
          display: flex;
          align-items: center;
          .img {
            width: 395px;
            height: 395px;
            margin: 0 10px;
            background-image: url("../../assets/about/focus-center.png");
            background-size: 100%;
          }
          .left, .right {
            width: calc((100% - 412px) / 2);
            height: 395px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
        }
      }
      .box-2 {
        margin-top: 35px;
        .tit {
          text-align: center;
        }
        .txt {
          text-align: center;
        }
      }
    }
    .research-area {
      margin-bottom: 92px;
      position: relative;
      padding-bottom: 66px;
      .area-list {
        display: flex;
        justify-content: space-between;
        margin-bottom: 48px;
        .area-item {
          width: calc((100% - 36px) / 3);
          position: relative;
          img {
            width: 100%;
            height: 205px;
            object-fit: cover;
            display: block;
          }
          .tit-box {
            width: 100%;
            height: 205px;
            position: absolute;
            top: 0;
            left: 0;
            background: #00000080;
            color: #fff;
            text-align: center;
            padding-top: 78px;
            p {
              font-size: 32px;
              line-height: 44px;
            }
          }
          .tit-box-3 {
            padding-top: 80px;
          }
          .desc-box {
            text-indent: 2em;
            height: 280px;
            line-height: 29px;
            padding: 37px 37px 0;
            background: #fff;
          }
          .en-desc-box {
            height: 405px;
          }
        }
      }

      .area-menu-list {
        display: flex;
        .am-item {
          width: 20%;
          text-align: center;
          position: relative;
          img {
            margin-bottom: 26px;
          }
          &:after {
            content: '';
            display: block;
            width: 1px;
            height: 112px;
            background: #6f6f6f;
            position: absolute;
            right: 0;
            top: 4px;
          }
          &:last-child {
            &:after {
              display: none;
            }
          }
        }
      }

      .bg-box {
        width: 100%;
        height: 372px;
        background: #eee;
        position: absolute;
        bottom: 0;
        z-index: -1;
      }
    }
    .scope-work {
      margin-bottom: 92px;
      .sw-item {
        display: flex;
        justify-content: space-between;
        padding-bottom: 40px;
        padding-top: 60px;
        border-bottom: 1px solid #6F6F6F;
        &:nth-child(odd) {
          flex-direction: row-reverse;
        }
        .order {
          width: 62px;
          height: 91px;
          background: #037698;
          border-bottom-right-radius: 4px;
          line-height: 89px;
          span {
            width: 100%;
            text-align: center;
            display: inline-block;
            font-size: 55px;
            font-weight: bolder;
            color: #fff;
            transform: scale(0.7, 1.1);
            letter-spacing: 5px;
          }
        }
        .txt-box {
          width: 435px;
          padding-top: 27px;
          .tit {
            font-size: 32px;
            color: #2e2e2e;
            line-height: 44px;
          }
          .sub-tit {
            font-size: 18px;
            color: #7b7b7b;
            letter-spacing: 2px;
            margin-bottom: 20px;
          }
          .line {
            width: 89px;
            height: 7px;
            background: #037698;
            border-radius: 4px;
            margin-bottom: 16px;
          }
          .desc-box {
            color: #2e2e2e;
            line-height: 25px;
            letter-spacing: 1px;
          }
          .img {
            width: 475px;
            height: 254px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
  .milstone {
    margin-bottom: 92px;
    >img {
      display: block;
      width: 100%;
      margin: 0 auto;
    }
  }
}
</style>
